const languages: any = {
    it: require('./it.json'),
    es: require('./es.json'),
    en: require('./en.json'),
    fr: require('./fr.json'),
    de: require('./de.json'),
};

export const getRequestedLanguages = (languageCode: string) => {
    if (languages[languageCode]) {
        return languages[languageCode];
    }
    return languages.en;
};
